import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';

export function pglyInitCodeEditors() {
    if (typeof wp.codeEditor === 'undefined') return {};

    const editors = {};

    const initEditor = (selector, mode) => {
        const el = document.querySelector(selector);
        if (!el) return null;

        // Remove old CodeMirror wrapper if exists
        const oldCm = el.parentNode.querySelector('.CodeMirror');
        if (oldCm) oldCm.remove();

        const settings = wp.codeEditor.defaultSettings ? _.clone(wp.codeEditor.defaultSettings) : {};
        settings.codemirror = _.extend({}, settings.codemirror, {
            mode,
            lineNumbers: true,
            lineWrapping: true,
            viewportMargin: Infinity,
            theme: 'default', // optional: add a theme
        });

        const wrapper = wp.codeEditor.initialize(el, settings);

        // Return the actual CodeMirror instance (unified for all types)
        if (wrapper && wrapper.codemirror) {
            // For JS editor, sometimes we need to refresh to fix gutter width
            if (mode === 'application/javascript') {
                wrapper.codemirror.refresh();
            }
            return wrapper.codemirror;
        }

        return wrapper;
    };

    editors.css = initEditor('#smcr-css-editor', 'text/css');
    editors.js = initEditor('#smcr-js-editor', 'application/javascript');
    editors.scss = initEditor('#smcr-scss-editor', 'text/x-scss');

    return editors;
}

const pglyEditors = { css: null, js: null, scss: null };
export async function openCustomScriptsModal() {
    const popup = document.getElementById('smcr-custom-scripts-popup');
    if (!popup) return;

    popup.style.display = 'block';

    if (!window.pglyEditors) {
        const editors = pglyInitCodeEditors();
        window.pglyEditors = {
            css: editors.css,
            js: editors.js,
            scss: editors.scss,
        };
    }

    let postId = null;

    // get post ID from wp library.
    if (typeof wp !== 'undefined' && wp.data && wp.data.select) {
        const editorPostId = wp.data.select('core/editor')?.getCurrentPostId();
        if (editorPostId) postId = editorPostId;
    }

    // get post ID from body class or URL.
    if (!postId) {
        const match = window.location.search.match(/[?&]post=(\d+)/);
        if (match) postId = parseInt(match[1], 10);
    }

    if (!postId) {
        console.error('Unable to determine post ID');
        return;
    }

    try {
        // Use relative path only, do NOT prepend site URL.
        const data = await apiFetch({
            path: `/smartcare/v1/get-scripts?post_id=${postId}`,
            method: 'GET',
        });

        if (window.pglyEditors.css) window.pglyEditors.css.setValue?.(data.css?.content || '');
        if (window.pglyEditors.js) window.pglyEditors.js.setValue?.(data.js?.content || '');
        if (window.pglyEditors.scss) window.pglyEditors.scss.setValue?.(data.scss?.content || '');

        popup.querySelector(
            '.smcr-tab-enable-checkbox[data-tab="css"] .smcr-enable'
        ).checked = !!data.css?.enabled;
        popup.querySelector(
            '.smcr-tab-enable-checkbox[data-tab="js"] .smcr-enable'
        ).checked = !!data.js?.enabled;
        popup.querySelector(
            '.smcr-tab-enable-checkbox[data-tab="scss"] .smcr-enable'
        ).checked = !!data.scss?.enabled;
    } catch (err) {
        console.error('Failed to load custom scripts:', err);
    }

    const saveBtn = popup.querySelector('.smcr-save');
    if (saveBtn) {
        saveBtn.onclick = async () => {
            const payload = {
                post_id: postId,
                css: {
                    content: window.pglyEditors.css?.getValue?.() || '',
                    enabled: popup.querySelector(
                        '.smcr-tab-enable-checkbox[data-tab="css"] .smcr-enable'
                    ).checked,
                },
                js: {
                    content: window.pglyEditors.js?.getValue?.() || '',
                    enabled: popup.querySelector(
                        '.smcr-tab-enable-checkbox[data-tab="js"] .smcr-enable'
                    ).checked,
                },
                scss: {
                    content: window.pglyEditors.scss?.getValue?.() || '',
                    enabled: popup.querySelector(
                        '.smcr-tab-enable-checkbox[data-tab="scss"] .smcr-enable'
                    ).checked,
                },
            };

            try {
                await apiFetch({
                    path: '/smartcare/v1/save-scripts',
                    method: 'POST',
                    data: payload,
                });
                alert(esc_html__('Saved successfully!', 'current-template-name'));
                popup.style.display = 'none';
            } catch (error) {
                console.error('Failed to save scripts:', error);
                alert(esc_html__('Failed to save scripts. Check console for errors.', 'current-template-name'));
            }
        };
    }
}